require.register("modules/m02/m02-activity/page-19-co/page-19-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page19co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page19co;

  
});

